import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const entryReducer = createReducer<State, Actions>(initialState, {
  [actions.deeplinkEntry.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.deeplinkEntry.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.deeplinkEntry.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.deeplinkEntry.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default entryReducer;
